<template>
  <div id="app" :style="appStyle">
    <div v-if="webSiteLoaded">
      <navigation :brand="logoInfo" :toggle="false" variant="light" type="light"></navigation>
      <navigation :brand="logoInfo" :navs="navs" navItemAlign="center" @toLink="toLink"></navigation>


      <router-view></router-view>
      <div v-if="show" class="floating-banner-a bg-light rounded-lg shadow d-none d-sm-block" @mouseover="mouseover"
           @mouseout="mouseout" :style="{'top':maxTop-100 + 'px','left':maxLeft+25 + 'px'}">
        <b-row cols="1">
          <b-col class="bg-primary text-white p-0 text-center rounded-lg" style="margin-left: -10px;">
            <b-icon icon="x-lg" class="b-icon-x-lg" @click="close"></b-icon>
            <svg class="bi bi-headphones" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor"
                 xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M8 3a5 5 0 0 0-5 5v4.5H2V8a6 6 0 1 1 12 0v4.5h-1V8a5 5 0 0 0-5-5z"/>
              <path
                  d="M11 10a1 1 0 0 1 1-1h2v4a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3zm-6 0a1 1 0 0 0-1-1H2v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3z"/>
            </svg>
            咨询热线
          </b-col>
          <b-col class="text-dark p-3 text-center">
            <b-row cols="1">
              <b-col class="text-dark p-0 text-center">029-81168482</b-col>
              <b-col class="text-dark p-0 text-center">13379220232</b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <div class="floating-banner-b bg-light rounded-lg shadow" v-if="scrollTopRun">
        <b-row cols="1" @click="scrollToTop">
          <b-col class="bg-primary text-white p-0 text-center rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                 class="bi bi-chevron-bar-up" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                    d="M3.646 11.854a.5.5 0 0 0 .708 0L8 8.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708zM2.4 5.2c0 .22.18.4.4.4h10.4a.4.4 0 0 0 0-.8H2.8a.4.4 0 0 0-.4.4z"/>
            </svg>
          </b-col>
          <b-col class="text-dark p-3 text-center">
            <b-row cols="1">
              <b-col class="text-dark p-0 text-center">回到顶部</b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-if="!webSiteLoaded" style="height: 100vh;width:100vw;"
         class="d-flex justify-content-center flex-column m-5 align-items-center">
      <b-spinner variant="primary" style="width: 8rem; height: 8rem;" type="grow" label="加载中"></b-spinner>
      <strong>Loading...</strong>
    </div>
  </div>
</template>

<script>

import logo from '@/assets/logo.png'
import navigation from '@/components/navigation.vue'
import {RouterView} from 'vue-router';

import {getWebSiteConfig, getWebSiteCategoryConfig, getWebSitePcCarousel} from '@/api/api.js'

export default {
  name: 'App',
  components: {
    navigation, RouterView
  },
  computed: {
    scrollTopRun() {
      let scrollTop = this.scrollY
      // let val = this.$refs.tableRef.bodyWrapper.scrollTop
      // console.log(scrollTop)
      if (scrollTop > 100) {
        return true
      } else {
        return false
      }
    },
    appStyle() {
      return {
        width: '100vw',
        margin: "0 auto",
        background: "#eee",
        'min-height': "100vh"
      }
    },

    logoInfo() {
      let config = sessionStorage.getItem('basisInfo') ? JSON.parse(sessionStorage.getItem('basisInfo')) : null
      let logo = {
        img: '',
        text: "易企跑"
      }
      if (config) {
        logo.img = `https://api.100xsys.cn/file/download?fileNo=${config.logo}`
      }

      return logo
    }
  },

  mounted() {
    this.init()
  },
  beforeDestroy() {
    // dom 销毁前清除定时器
    clearInterval(this.timer)
  },
  created() {
    this.getWebSiteConfigs()
    window.addEventListener('scroll', this.handleScroll, true)
  },
  data() {
    return {
      show: true, // 是否展现飘窗
      stepX: 1, // 水平方向的步长
      stepY: 1, // 垂直方向的步长
      timer: null, // 定时器
      maxTop: 0, // 最大的 top 值
      maxLeft: 0, // 最大的 left 值
      top: 0,
      left: 0,
      scrollY: 0,
      webSiteLoaded: false,
      isload: [],
      routerVal: null,
      navs: [
        {
          text: '首页',
          key: "home",
          href: '/',
          active: true
        },
        {
          text: '政策数据',
          href: '#',
          key: "",
          icon: "",
          children: [{
            text: '最新政策',
            href: '/policy',
            key: "",
            icon: "",
            active: true
          }, {
            text: '每日简报',
            href: '/briefing',
            key: "",
            icon: "",
            active: true
          }, {
            text: '方案评估',
            href: '#',
            key: "",
            icon: "",
            active: true
          }]
        },
        {
          text: '行业现状',
          href: '#',
          key: "",
          icon: "",
          active: false
        },
        // {
        //     text: '政策资讯',
        //     href: '#',
        //     key:"",
        //     icon:"",
        //     children:[{
        //         text: '最新政策',
        //         href: '#',
        //         key:"",
        //         icon:"",
        //         active: false
        //     },{
        //         text: '每日简报',
        //         href: '#',
        //         key:"",
        //         icon:"",
        //         active: false
        //     },{
        //         text: '方案评估',
        //         href: '#',
        //         key:"",
        //         icon:"",
        //         active: false
        //     }]
        // },
        {
          text: '政策匹配',
          href: '#',
          key: "",
          icon: "",
          active: false
        },
        {
          text: '关于我们',
          href: '#',
          key: "",
          icon: "",
          active: false
        }
      ]
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleScroll(e) {
      //  console.log('handleScroll',e)
      this.scrollY = window.scrollY
    },
    toLink(e) {
      this.routerVal = e
    },
    getWebSiteConfigs() {
      this.isload = []
      getWebSiteConfig().then(res => {
        //  console.log('网站信息',res)
        if (res.state == "SUCCESS") {
          let data = res.data[0]
          sessionStorage.setItem('basisInfo', JSON.stringify(data))
          this.isload.push('getWebSiteConfig')
        } else {
          console.error('网站信息加载失败')
          this.webSiteLoaded = false
        }
      })
      getWebSiteCategoryConfig().then(res => {
        //  console.log('网站信息',res)
        if (res.state == "SUCCESS") {
          let data = res.data
          this.buildNavs(data)
          this.isload.push('getWebSiteCategoryConfig')
        } else {
          console.error('网站信息加载失败')
        }
      })
      getWebSitePcCarousel().then(res => {
        //  console.log('网站信息',res)
        if (res.state == "SUCCESS") {
          let data = res.data
          sessionStorage.setItem('webSitePcCarousel', JSON.stringify(data))
          this.isload.push('getWebSitePcCarousel')
        } else {
          console.error('网站信息加载失败')
          this.webSiteLoaded = false
        }
      })
    },
    buildNavs(list) {
      let navs = []
      if (list && list.length > 0) {
        // list = list.map(item => {
        //   // let obj = {
        //   //   text: item.name,
        //   //   key:item.no,
        //   //   href: item.temp_file_name,
        //   // }
        //   // obj["_data"] = item
        //   return item
        // })
        this.navs = list.map(item => item)
        this.navs[0]['avtiveChildText'] = this.navs[0].name
        sessionStorage.setItem('avtiveNav', JSON.stringify(this.navs[0]))
      }

    },
    init() {
      // 设置最大的top和left值：根元素可视区域宽高 - 飘窗的宽高 - 边距
      this.maxTop = document.documentElement.clientHeight - 150 - 20
      this.maxLeft = document.documentElement.clientWidth - 200 - 20

      // 设置 top 和 left 的初始值
      this.top = 0
      this.left = 0

      // 创建定时器前清除定时器，避免类似在 onresize 中调用 init() 时，产生多个定时器
      // clearInterval(this.timer)
      // this.timer = setInterval(() => {
      //   this.move()
      // }, 20)

      this.onresize()
    },
    // 移动函数
    move() {
      if (this.top >= this.maxTop || this.top < 0) {
        this.stepY = -this.stepY
      }
      if (this.left >= this.maxLeft || this.left < 0) {
        this.stepX = -this.stepX
      }

      this.top += this.stepY
      this.left += this.stepX
    },
    // 鼠标悬浮在飘窗时停止移动
    mouseover() {
      clearInterval(this.timer)
    },
    // 鼠标离开飘窗时恢复移动
    mouseout() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.move()
      }, 20)
    },
    // 关闭飘窗
    close() {
      clearInterval(this.timer)
      this.show = false
    },
    // 窗口大小调整时重置飘窗规则
    onresize() {
      const that = this
      window.onresize = function () {
        that.init()
      }
    }
  },
  watch: {
    "isload": {
      deep: true,
      handler: function (nval, oval) {
        // console.log(nval,oval)
        if (nval.length == 3) {
          this.webSiteLoaded = true
        }
      }
    },
  }
}
</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.floating-banner-a {
  overflow: hidden;
  display: block;
  position: fixed;
  width: 12rem;
  /* height: 12rem; */
  top: 0;
  left: 0;
  z-index: 9999;
  /* bottom: 7rem; */
  /* background: blue; */
  border-radius: 2rem;
  line-height: 3rem;
  font-size: 1.5rem;
  font-weight: bold;

}

.b-icon-x-lg {
  position: absolute;
  right: 15px;
  top: 12px;
  font-size: 20px;
  cursor: pointer;
}

.floating-banner-b {
  overflow: hidden;
  display: block;
  position: fixed;
  width: 3.5rem;
  /* height: 12rem; */
  right: 0;
  bottom: 2rem;
  /* background: blue; */
  border-radius: 2rem;
  line-height: 1;
  font-size: 0.6rem;
  font-weight: bold;
  cursor: pointer;
}
</style>
